export default __webpack_public_path__ + "static/media/face-with-look-of-triumph.ab0eb597.png";